export default {
  globalConfig: {
    title: 'グローバル設定',
  },
}
